import React from 'react';

import { useCustomReports } from 'lib/hooks/queries/reports/useCustomReports';

import Header from 'components/shared/Header/Header';

import ReportListView from '../../components/ReportListView/ReportListView';

const CustomReports = () => {
  return (
    <div className="flex h-full flex-col bg-white">
      <Header title="Custom Reports" />
      <ReportListView useData={useCustomReports} />
    </div>
  );
};

export default CustomReports;
